import React from 'react';

/**
 * CustomersTable - Table view for customer list
 * Displays: name, city/state, contact, phone, email, status, actions
 */
const CustomersTable = ({
  customers,
  isAdmin,
  onView,
  onEdit,
  onDelete
}) => {
  const stop = (e) => e.stopPropagation();

  return (
    <div className="customers-table-container">
      <table className="customers-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>City, State</th>
            <th>Contact</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {customers.map(customer => (
            <tr
              key={customer.id}
              className="clickable-row"
              onClick={() => onView(customer)}
            >
              <td className="customer-name">{customer.name}</td>
              <td>{customer.city}, {customer.state}</td>
              <td>{customer.contact_person || '-'}</td>
              <td>{customer.phone || '-'}</td>
              <td>{customer.email || '-'}</td>
              <td>
                <span className={`status-badge ${customer.status}`}>
                  {customer.status}
                </span>
              </td>
              <td className="actions-cell" onClick={stop}>
                {isAdmin ? (
                  <>
                    <button
                      className="action-btn edit"
                      onClick={() => onEdit(customer)}
                    >
                      Edit
                    </button>
                    <button
                      className="action-btn delete"
                      onClick={() => onDelete(customer)}
                    >
                      Delete
                    </button>
                  </>
                ) : (
                  <button
                    className="action-btn view"
                    onClick={() => onView(customer)}
                  >
                    View
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CustomersTable;
